const React = require('react');
const { formatText } = require('core/i18n').i18n;
require('./GlossaryFooter.scss');


const GlossaryFooter = () => (
    <div className="glossary__footer">
        <p>{formatText('glossary-disclaimer')}</p>
    </div>
);


module.exports = GlossaryFooter;
